import React, { useState, useEffect } from 'react'

import { getFullDisplayableWholeSalers } from '../../../components/Navigation/Footer/whole-sale-sorter.js'
import { isLocal } from '../../../spa/utility'
import { getAbsolutePath } from '../../../global/environments/path.js'
import { getWholesalerFromcookies } from '../../../spa/components/wholesaler/utils.js'
import {
  getAuthManagerInstance,
  isLoggedIn,
  isInstitutional,
} from '../../../global/authentication/authentication-manager.js'

import ErrorState from './ErrorState.jsx'
import './index.css'
import DOMPurify from 'dompurify'

const bgImage = `${
  isLocal() ? '/cti-site' : ''
}/webfiles/latest/assets/cti/images/brand-texture-light-reversed.jpg`

const bgStyles = {
  backgroundImage: `url(${bgImage})`,
}

function ConsultantCard({ consultant = {} }) {
  const {
    preferredFirstNm,
    preferredLastNm,
    titleCd,
    designationCd,
    phoneNbr,
    emailId,
    photoURL,
  } = consultant

  return (
    <div className="Card u-padding2gu u-flex">
      <div className="image-circle u-marginRight2gu">
        <img
          src={
            photoURL
              ? photoURL
              : '/binaries/content/gallery/cti-blog/imported/cti-blank-profile.jpg/cti-blank-profile.jpg'
          }
          alt={`${preferredFirstNm} ${preferredLastNm}`}
        />
      </div>
      <div className="info u-inlineBlock">
        <p data-analytics="sales-consultant-name">
          {preferredFirstNm} {preferredLastNm}
          {designationCd && (
            <>
              , <span>{designationCd}</span>
            </>
          )}
        </p>
        <p className="u-textSizeMsrm1 u-textColorLight">{titleCd}</p>
        <p>
          <a
            href={DOMPurify.sanitize(
              `${getAbsolutePath(
                true
              )}/about/contact-us/sc/email?emailId=${emailId}`
            )}
            className="Link"
            data-analytics="sales-consultant-email-link"
          >
            Email {preferredFirstNm}
          </a>
        </p>
        <p>
          <a
            href={`tel:${phoneNbr}`}
            className="Link"
            data-analytics="sales-consultant-phone-number-link"
          >
            {phoneNbr}
          </a>
        </p>
      </div>
    </div>
  )
}

function ConsultantRow({ rowInfo = {} }) {
  const { functionalAreaNm, salesContactInfo } = rowInfo

  return (
    <div className="Grid-cell u-size4of12">
      <h4>{functionalAreaNm}</h4>
      {salesContactInfo.map((consultant) => (
        <ConsultantCard
          key={consultant.preferredFirstNm}
          consultant={consultant}
        />
      ))}
    </div>
  )
}

function LoggedInTray({ show, consultants = [] }) {
  const [wholesalers, setWholesalers] = useState(consultants)

  useEffect(() => {
    if (isInstitutional()) {
      const RM_data = getWholesalerFromcookies()
      const contactInfoExists =
        RM_data?.preferredFirstNm && RM_data?.emailId && RM_data?.phoneNbr
      const wholsalerData = contactInfoExists ? [RM_data] : []
      setWholesalers(wholsalerData)
    } else {
      if (isLoggedIn()) {
        getAuthManagerInstance()
          .getProfileServiceBehaviorSubject()
          .subscribe((profile) => {
            const results = getFullDisplayableWholeSalers(profile)
            const wholesalersExist = results && results.length
            const wholesalerData = wholesalersExist ? results : []
            setWholesalers(wholesalerData)
          })
      }
    }
  }, [])

  if (wholesalers.length > 0) {
    return (
      <div
        className={`${
          show ? 'consultant-container' : ''
        } consultant-contact-tray -logged-in u-sm-hidden`}
        style={bgStyles}
      >
        <div className="Grid u-sizeConstrained u-paddingTop8gu">
          {wholesalers.map((group) => (
            <ConsultantRow key={group.functionalAreaNm} rowInfo={group} />
          ))}
        </div>
        <div className="u-paddingTop6gu u-sizeConstrained u-paddingBottom8gu">
          <a
            href={DOMPurify.sanitize(
              `${getAbsolutePath(true)}/about/contact-us`
            )}
            className="u-textPrimary"
            data-analytics="sales-consultant-view-all-contact-options"
          >
            View all contact options{' '}
            <span aria-hidden="true" className="Icon--material">
              chevron_right
            </span>
          </a>
        </div>
      </div>
    )
  }
  if (!wholesalers.length) {
    return <ErrorState show={show} />
  }
  return null
}

export default LoggedInTray
